module.exports = __webpack_public_path__ + "img/couponY.ec7b8f49.png";